import { I18nService } from 'i18n/i18n.service';
import { EnvironmentCustomService } from './services/environment-custom.service';
import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { AddPropertyModalComponent } from './add-property-modal/add-property-modal';
import { TranslateService } from '@ngx-translate/core';
import 'datatables.net';
@Component({
  selector: 'environment-custom',
  templateUrl: './environment-custom.component.html',
  styleUrls: ['./environment-custom.component.scss']
})
export class EnvironmentCustomComponent implements OnInit {
  public customMetadataArray: ICustomMetadata[] = [];
  public language: string;
  public screenHeight: number;
  public pageLength: number;
  public isOpenModalDelete: boolean = false;

  private dataTableRef: any;
  private columns: any = [];
  // ===== table =======
  @ViewChild('dataTable', { static: true }) dataTable: ElementRef;

  constructor(public envCustomService: EnvironmentCustomService,
    private _i18nService: I18nService,
    private renderer: Renderer2,
    private _modalService: BzgModalService,
    private _toastService: BzgToastService,
    private _translateService: TranslateService) {
  }

  async ngOnInit() {
    this.defineColums();
    this.language = this._translateService.getBrowserLang();
    this.screenHeight = window.innerHeight;
    this.setElements();
    this.initDataTable();
  };

  defineColums() {
    this.columns = [
      {
        title: this._i18nService.instant('ENVIRONMENT.COLUMN_NAME'),
        data: 'name',
        className: 'bs-data-table__name',
        render: (data: any, type: any) => {
          if (type === 'display') {
            return `<p>${data}</p>`;
          }
          return data;
        }
      },
      {
        title: this._i18nService.instant('ENVIRONMENT.COLUMN_VALUE'),
        data: 'default',
        className: 'bs-data-table__value',
        render: (data: any, type: any) => {
          if (type === 'display') {
            return `<input type="text" value="${data}"  />`;
          }
          return data;
        }
      },
      {
        title: this._i18nService.instant('ENVIRONMENT.COLUMN_DESCRIPTION'),
        data: 'description',
        className: 'bs-data-table__description',
        render: (data: any, type: any) => {
          if (type === 'display') {
            return `<p>${data}</p>`;
          }
          return data;
        }
      },
      {
        title: '',
        className: 'bs-data-table__delete',
        data: null,
        orderable: false,
        render: (data: any, type: any, row: any) => {
          if (type === 'display') {
            return `<i class="bz-icon bz-icon-trash custom_delete"></i>`;
          }
          return data;
        }
      }
    ];
  }

  setElements() {
    this.pageLength = 3;
    if (this.screenHeight >= 600 && this.screenHeight < 700)
      this.pageLength = 4;
    if (this.screenHeight >= 700 && this.screenHeight < 780)
      this.pageLength = 5;
    if (this.screenHeight >= 780 && this.screenHeight < 900)
      this.pageLength = 6;
    if (this.screenHeight >= 900)
      this.pageLength = 8;
  }

  initDataTable() {
    this.customMetadataArray = this.envCustomService.customMetadataArray;
    const customsArray = this.envCustomService.customsArray[this.envCustomService.currentCustomIndex];
    const customMetadataArray = this.envCustomService.customMetadataArray;
    customMetadataArray.forEach(item => {
      if (customsArray.hasOwnProperty(item.name))
        item.default = customsArray[item.name];
    });
    this.dataTableRef = $(this.dataTable.nativeElement).DataTable({
      data: customMetadataArray,
      columns: this.columns,
      language: {
        searchPlaceholder: this._i18nService.instant('ENVIRONMENT.SEARCH'),
        zeroRecords: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        info: this._i18nService.instant('ENVIRONMENT.PAGINATOR_INFO'),
        infoEmpty: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        infoFiltered: '',
        emptyTable: this._i18nService.instant('ENVIRONMENT.NO_DATA'),
        paginate: {
          first: this._i18nService.instant('ENVIRONMENT.FIRST'),
          last: this._i18nService.instant('ENVIRONMENT.LAST'),
          next: this._i18nService.instant('ENVIRONMENT.NEXT'),
          previous: this._i18nService.instant('ENVIRONMENT.PREVIOUS')
        }
      },
      pageLength: this.pageLength,

      drawCallback: () => {
        this.tableActions();
      },
      rowCallback: (row, data: any) => {
        $(row).find('td:eq(0)').attr('title', data.name);
        $(row).find('td:eq(1)').attr('title', data.default);
        $(row).find('td:eq(2)').attr('title', data.description);
      }
    });
  }

  tableActions() {
    const valueInputs = this.dataTable.nativeElement.querySelectorAll('input');
    valueInputs.forEach(cell => {
      this.renderer.listen(cell, 'blur', ($event) => {
        const name = cell.closest('tr').querySelector('td:first-child').textContent;
        const value = cell.closest('tr').querySelector('td:nth-child(2) input').value;
        const description = cell.closest('tr').querySelector('td:nth-child(3)').textContent;
        this.onInputBlur(name, value, description);
      });
    });

    const deleteIcon = this.dataTable.nativeElement.querySelectorAll('i');
    deleteIcon.forEach(cell => {
      this.renderer.listen(cell, 'click', ($event) => {
        const name = cell.closest('tr').querySelector('td:first-child').textContent;
        this.deleteCustom(name);
      });
    });
  }

  onInputBlur(name, value, description) {
    const customMetadata: ICustomMetadata = { name, default: value, description };
    this.envCustomService.editCustomMetadataProperty(name, customMetadata);
  }

  deleteCustom(name) {
    if (!this.isOpenModalDelete) {
      this.isOpenModalDelete = true;
      const title = this._i18nService.instant('ENVIRONMENT.DELETE_PROPERTY');
      const message = this._i18nService.instant('ENVIRONMENT.DELETE_PROPERTY_MESSAGE').replace('{{0}}', name);
      const modal = this._modalService.open(DeleteConfirmationComponent, {
        closeOnBackdropClick: false,
        closeOnRouterNavigation: true,
        data: { title, message, button: 'GLOBAL.DELETE' }
      });
      modal.afterClosed().subscribe((result) => {
        this.isOpenModalDelete = false;
        if (result === 'delete') {
          this.envCustomService.deleteCustomPropertyForAllEnvironments(name);
          this.customMetadataArray = this.envCustomService.customMetadataArray;
          this.dataTableRef.clear().rows.add(this.customMetadataArray).draw();
        }
      });
    }
  }

  addProperty() {
    const modal = this._modalService.open(AddPropertyModalComponent, {
      closeOnBackdropClick: false,
      width: '500px',
      maxWidth: 'none',
      maxHeight: '50%',
      closeOnRouterNavigation: true
    });

    modal.afterClosed().subscribe(result => {
      if (result && result.name) {
        if (!this.validateCustomProperty(result.name)) {
          this.envCustomService.addCustomProperty(result);
          this.customMetadataArray = this.envCustomService.customMetadataArray;
          this.dataTableRef.settings()[0].oFeatures.bSort = false;
          this.dataTableRef.clear().rows.add(this.customMetadataArray).draw();
          this.dataTableRef.settings()[0].oFeatures.bSort = true;
        } else {
          this.showToast(this._i18nService.instant('ENVIRONMENT.PROPERTY_WITH_THE_SAME_NAME'), 'error');
        }
      }
    });
  }

  validateCustomProperty(name) {
    return this.customMetadataArray.find(custom => custom.name === name);
  }

  showToast(messageInput: string, type: BzgToastType) {
    this._toastService.open(
      messageInput,
      {
        type,
        duration: 5000,
        verticalPosition: 'bottom',
        horizontalPosition: 'right'
      });
  }
}

